import React, { useState, useEffect } from 'react';
import ContextMenu from 'app/shared/datatable/context-menu/context-menu';

import styles from './item.module.css';
import { Icon } from 'assets/icons';
import { Checkbox } from 'app/shared/input/checkbox';

const DataTableItem = (props) => {
  const {
    actions,
    action_callback,
    checkbox,
    data,
    bulk_selection,
    fields,
    index,
    item_click_callback,
    selection_callback,
    unselection_callback
  } = props;

  const [row_data, setRowData] = useState([]);
  const [is_selected, setIsSelected] = useState(false);

  useEffect(() => {
    const field_keys = {};
    const cells = [];
    fields.forEach((field, index) => {
      field_keys[field.key] = field;
      if (field.formatter) {
        const value = field.formatter(data[field.key]);
        cells.push(
          <td onClick={() => item_click_callback(data)} key={`${index}-${data[field.key]}`}>
            {value}
          </td>
        );
        return;
      }

      cells.push(
        <td onClick={() => item_click_callback(data)} key={`${index}-${data[field.key]}`}>
          {data[field.key]}
        </td>
      );
    });

    setRowData(cells);
  }, [data, fields, index, item_click_callback]);

  useEffect(() => {
    setIsSelected(() => bulk_selection[index]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bulk_selection]);

  const processAction = (action) => {
    action_callback(action, data);
  };

  const handleItemSelection = () => {
    if (!checkbox) return;
    if (!is_selected) selection_callback(data);
    else unselection_callback(data.id);
  };

  return (
    <tr className={styles.item}>
      <td key={`checkbox-${index}`}>
        <span className={styles.checkboxWrapper}>
          <Checkbox checked={is_selected} onClick={handleItemSelection} />
        </span>
      </td>
      {row_data}

      {actions ? (
        <td key={`action-${index}`}>
          <div className={styles.actionBtnWrapper}>
            <ContextMenu
              actions={actions(data)}
              callback={processAction}
              text={<Icon height={20} width={20} name="more_vert" />}
            />
          </div>
        </td>
      ) : (
        ''
      )}
    </tr>
  );
};

export default DataTableItem;
